export const RESEND_COOLDOWN = 120;
export const CODE_EXPIRATION_COOLDOWN = 300;
export const PHONE_CHAR_LIMIT = 16;
